export default "__VITE_ASSET__CRffBIC0__"